export default function formatPrice(total, currency = "") {
  const amount = total;
  const integers = Math.floor(amount / 100);
  let cents = amount % 100;
  cents = cents.toFixed(0);
  return `${currency} ${integers},${cents}`;
}
